import React from 'react';

import { useDispatch, useSelector } from "react-redux";

const PreloaderShop = () => {

    const theme = useSelector((state) => state.initData.theme);

    return (
        <>
            {theme == 'dark' && (
                <svg width="375" height="770" viewBox="0 0 375 770" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_0_1924)">
                    <rect x="16" y="40" width="343" height="186" fill="#2C2C2E"/>
                    </g>
                    <g filter="url(#filter0_b_0_1924)">
                    <rect x="16" y="250" width="343" height="72" rx="16" fill="#2C2C2E"/>
                    </g>
                    <g filter="url(#filter1_b_0_1924)">
                    <rect x="16" y="334" width="107" height="16" rx="8" fill="#2C2C2E"/>
                    </g>
                    <g filter="url(#filter2_b_0_1924)">
                    <rect x="16" y="382" width="129" height="24" rx="12" fill="#2C2C2E"/>
                    </g>
                    <g filter="url(#filter3_b_0_1924)">
                    <rect x="16" y="418" width="207" height="16" rx="8" fill="#2C2C2E"/>
                    </g>
                    <g filter="url(#filter4_b_0_1924)">
                    <rect x="16" y="438" width="183" height="16" rx="8" fill="#2C2C2E"/>
                    </g>
                    <g filter="url(#filter5_b_0_1924)">
                    <rect x="16" y="458" width="283" height="16" rx="8" fill="#2C2C2E"/>
                    </g>
                    <g filter="url(#filter6_b_0_1924)">
                    <rect x="16" y="478" width="234" height="16" rx="8" fill="#2C2C2E"/>
                    </g>
                    <g filter="url(#filter7_b_0_1924)">
                    <rect x="16" y="498" width="252" height="16" rx="8" fill="#2C2C2E"/>
                    </g>
                    <rect x="20" y="626" width="335" height="56" rx="12" fill="#2C2C2E"/>
                    <rect x="20" y="698" width="335" height="56" rx="12" fill="#2C2C2E"/>
                    <defs>
                    <filter id="filter0_b_0_1924" x="-24" y="210" width="423" height="152" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="20"/>
                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_0_1924"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_0_1924" result="shape"/>
                    </filter>
                    <filter id="filter1_b_0_1924" x="-24" y="294" width="187" height="96" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="20"/>
                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_0_1924"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_0_1924" result="shape"/>
                    </filter>
                    <filter id="filter2_b_0_1924" x="-24" y="342" width="209" height="104" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="20"/>
                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_0_1924"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_0_1924" result="shape"/>
                    </filter>
                    <filter id="filter3_b_0_1924" x="-24" y="378" width="287" height="96" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="20"/>
                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_0_1924"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_0_1924" result="shape"/>
                    </filter>
                    <filter id="filter4_b_0_1924" x="-24" y="398" width="263" height="96" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="20"/>
                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_0_1924"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_0_1924" result="shape"/>
                    </filter>
                    <filter id="filter5_b_0_1924" x="-24" y="418" width="363" height="96" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="20"/>
                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_0_1924"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_0_1924" result="shape"/>
                    </filter>
                    <filter id="filter6_b_0_1924" x="-24" y="438" width="314" height="96" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="20"/>
                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_0_1924"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_0_1924" result="shape"/>
                    </filter>
                    <filter id="filter7_b_0_1924" x="-24" y="458" width="332" height="96" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="20"/>
                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_0_1924"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_0_1924" result="shape"/>
                    </filter>
                    <clipPath id="clip0_0_1924">
                    <rect x="16" y="40" width="343" height="186" rx="8" fill="white"/>
                    </clipPath>
                    </defs>
                </svg>            
            ) || (
                <svg
                    width="375"
                    height="770"
                    viewBox="0 0 375 770"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g clip-path="url(#clip0_0_2762)">
                        <g clip-path="url(#clip1_0_2762)">
                            <rect
                                x="16"
                                y="8"
                                width="343"
                                height="186"
                                fill="#E9E9EB"
                            />
                        </g>
                        <g filter="url(#filter0_b_0_2762)">
                            <rect
                                x="16"
                                y="218"
                                width="343"
                                height="72"
                                rx="16"
                                fill="#E9E9EB"
                            />
                        </g>
                        <g filter="url(#filter1_b_0_2762)">
                            <rect
                                x="16"
                                y="302"
                                width="107"
                                height="16"
                                rx="8"
                                fill="#E9E9EB"
                            />
                        </g>
                        <g filter="url(#filter2_b_0_2762)">
                            <rect
                                x="16"
                                y="350"
                                width="129"
                                height="24"
                                rx="12"
                                fill="#E9E9EB"
                            />
                        </g>
                        <g filter="url(#filter3_b_0_2762)">
                            <rect
                                x="16"
                                y="386"
                                width="207"
                                height="16"
                                rx="8"
                                fill="#E9E9EB"
                            />
                        </g>
                        <g filter="url(#filter4_b_0_2762)">
                            <rect
                                x="16"
                                y="406"
                                width="183"
                                height="16"
                                rx="8"
                                fill="#E9E9EB"
                            />
                        </g>
                        <g filter="url(#filter5_b_0_2762)">
                            <rect
                                x="16"
                                y="426"
                                width="283"
                                height="16"
                                rx="8"
                                fill="#E9E9EB"
                            />
                        </g>
                        <g filter="url(#filter6_b_0_2762)">
                            <rect
                                x="16"
                                y="446"
                                width="234"
                                height="16"
                                rx="8"
                                fill="#E9E9EB"
                            />
                        </g>
                        <g filter="url(#filter7_b_0_2762)">
                            <rect
                                x="16"
                                y="466"
                                width="252"
                                height="16"
                                rx="8"
                                fill="#E9E9EB"
                            />
                        </g>
                        <rect
                            x="20"
                            y="626"
                            width="335"
                            height="56"
                            rx="12"
                            fill="#E9E9EB"
                        />
                        <rect
                            x="20"
                            y="698"
                            width="335"
                            height="56"
                            rx="12"
                            fill="#E9E9EB"
                        />
                    </g>
                    <defs>
                        <filter
                            id="filter0_b_0_2762"
                            x="-24"
                            y="178"
                            width="423"
                            height="152"
                            filterUnits="userSpaceOnUse"
                            colorInterpolationFilters="sRGB"
                        >
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />
                            <feGaussianBlur in="BackgroundImageFix" stdDeviation="20" />
                            <feComposite
                                in2="SourceAlpha"
                                operator="in"
                                result="effect1_backgroundBlur_0_2762"
                            />
                            <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_backgroundBlur_0_2762"
                                result="shape"
                            />
                        </filter>
                        <filter
                            id="filter1_b_0_2762"
                            x="-24"
                            y="262"
                            width="187"
                            height="96"
                            filterUnits="userSpaceOnUse"
                            colorInterpolationFilters="sRGB"
                        >
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />
                            <feGaussianBlur in="BackgroundImageFix" stdDeviation="20" />
                            <feComposite
                                in2="SourceAlpha"
                                operator="in"
                                result="effect1_backgroundBlur_0_2762"
                            />
                            <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_backgroundBlur_0_2762"
                                result="shape"
                            />
                        </filter>
                        <filter
                            id="filter2_b_0_2762"
                            x="-24"
                            y="310"
                            width="209"
                            height="104"
                            filterUnits="userSpaceOnUse"
                            colorInterpolationFilters="sRGB"
                        >
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />
                            <feGaussianBlur in="BackgroundImageFix" stdDeviation="20" />
                            <feComposite
                                in2="SourceAlpha"
                                operator="in"
                                result="effect1_backgroundBlur_0_2762"
                            />
                            <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_backgroundBlur_0_2762"
                                result="shape"
                            />
                        </filter>
                        <filter
                            id="filter3_b_0_2762"
                            x="-24"
                            y="346"
                            width="287"
                            height="96"
                            filterUnits="userSpaceOnUse"
                            colorInterpolationFilters="sRGB"
                        >
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />
                            <feGaussianBlur in="BackgroundImageFix" stdDeviation="20" />
                            <feComposite
                                in2="SourceAlpha"
                                operator="in"
                                result="effect1_backgroundBlur_0_2762"
                            />
                            <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_backgroundBlur_0_2762"
                                result="shape"
                            />
                        </filter>
                        <filter
                            id="filter4_b_0_2762"
                            x="-24"
                            y="366"
                            width="263"
                            height="96"
                            filterUnits="userSpaceOnUse"
                            colorInterpolationFilters="sRGB"
                        >
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />
                            <feGaussianBlur in="BackgroundImageFix" stdDeviation="20" />
                            <feComposite
                                in2="SourceAlpha"
                                operator="in"
                                result="effect1_backgroundBlur_0_2762"
                            />
                            <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_backgroundBlur_0_2762"
                                result="shape"
                            />
                        </filter>
                        <filter
                            id="filter5_b_0_2762"
                            x="-24"
                            y="386"
                            width="363"
                            height="96"
                            filterUnits="userSpaceOnUse"
                            colorInterpolationFilters="sRGB"
                        >
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />
                            <feGaussianBlur in="BackgroundImageFix" stdDeviation="20" />
                            <feComposite
                                in2="SourceAlpha"
                                operator="in"
                                result="effect1_backgroundBlur_0_2762"
                            />
                            <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_backgroundBlur_0_2762"
                                result="shape"
                            />
                        </filter>
                        <filter
                            id="filter6_b_0_2762"
                            x="-24"
                            y="406"
                            width="314"
                            height="96"
                            filterUnits="userSpaceOnUse"
                            colorInterpolationFilters="sRGB"
                        >
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />
                            <feGaussianBlur in="BackgroundImageFix" stdDeviation="20" />
                            <feComposite
                                in2="SourceAlpha"
                                operator="in"
                                result="effect1_backgroundBlur_0_2762"
                            />
                            <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_backgroundBlur_0_2762"
                                result="shape"
                            />
                        </filter>
                        <filter
                            id="filter7_b_0_2762"
                            x="-24"
                            y="426"
                            width="332"
                            height="96"
                            filterUnits="userSpaceOnUse"
                            colorInterpolationFilters="sRGB"
                        >
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />
                            <feGaussianBlur in="BackgroundImageFix" stdDeviation="20" />
                            <feComposite
                                in2="SourceAlpha"
                                operator="in"
                                result="effect1_backgroundBlur_0_2762"
                            />
                            <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_backgroundBlur_0_2762"
                                result="shape"
                            />
                        </filter>
                        <clipPath id="clip0_0_2762">
                            <rect width="375" height="770" rx="16" fill="white" />
                        </clipPath>
                        <clipPath id="clip1_0_2762">
                            <rect
                                x="16"
                                y="8"
                                width="343"
                                height="186"
                                rx="8"
                                fill="white"
                            />
                        </clipPath>
                    </defs>
                </svg>
            )}
        </>
    );
};

export default PreloaderShop;
